import { colors } from '../../colors';
var pagination = {
  activeColor: colors.rust,
  defaultColor: colors.graphite
};
export default pagination;